import React from "react"
import { Text, ContactCard } from "@capioweb/ui-components"

interface CareerItemProps {
	displayName: string
	county: string
	unit: string
	applyByDate: string
}

export const CareerItem: React.FC<CareerItemProps> = ({
	displayName,
	county,
	unit,
	applyByDate,
}) => {
	return (
		<ContactCard>
			<Text variant="headline-4" mb={1} mr={2}>
				{displayName}
			</Text>
			<Text fontSize={1.75} lineHeight={2.5} mb={0} textTransform="uppercase">
				{county}
			</Text>
			<Text fontSize={1.75} lineHeight={2.5} mb={0}>
				{unit}
			</Text>
			{applyByDate && (
				<Text fontSize={1.75} lineHeight={2.5} mb={0}>
					{applyByDate}
				</Text>
			)}
		</ContactCard>
	)
}
